module.exports = __webpack_public_path__ + "media/application/images/ui/badge-trusted-with-text-xs-cb5ce772e797e9d059e1a18605ba4e40.png";